import React from 'react';
import { X, EyeOff } from 'lucide-react';
import useSettingsStore from '../../stores/settingsStore';

const SettingsModal = () => {
    const { showSettingsModal, closeSettings, blurPII, toggleBlurPII } = useSettingsStore();

    if (!showSettingsModal) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
            onClick={closeSettings}
        >
            <div
                className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-md mx-4"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
                    <h2 className="text-lg font-bold text-gray-800">Settings</h2>
                    <button
                        onClick={closeSettings}
                        className="!p-1.5 !bg-transparent !border !border-gray-200 !rounded-lg hover:!bg-gray-100 !text-gray-400 hover:!text-gray-600 !transition-colors"
                    >
                        <X size={16} />
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-5 space-y-4">
                    {/* Blur PII Toggle */}
                    <div className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                            <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-indigo-50 text-indigo-600">
                                <EyeOff size={18} />
                            </div>
                            <div>
                                <p className="text-sm font-semibold text-gray-800">Demo Mode</p>
                                <p className="text-xs text-gray-500">Blur names, emails, and phone numbers</p>
                            </div>
                        </div>
                        <button
                            onClick={toggleBlurPII}
                            className={`!relative !inline-flex !h-6 !w-11 !items-center !rounded-full !border-none !transition-colors !duration-200 !ease-in-out ${
                                blurPII ? '!bg-indigo-600' : '!bg-gray-300'
                            }`}
                            role="switch"
                            aria-checked={blurPII}
                        >
                            <span
                                className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out ${
                                    blurPII ? 'translate-x-6' : 'translate-x-1'
                                }`}
                            />
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-3 border-t border-gray-100 flex justify-end">
                    <button
                        onClick={closeSettings}
                        className="!px-4 !py-2 !text-sm !font-medium !text-gray-600 !bg-gray-100 !border-none !rounded-lg hover:!bg-gray-200 !transition-colors"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;
